import axios from 'axios'
import store from '../vuex/store'
import { Loading } from 'element-ui'
import vue from '../main'

let loading
// 加载开始
function startLoading () {
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}

// 加载停止
function endLoading () {
  loading.close()
}

// 调用加载开始
let needLoadingRequestCount = 0
export function showFullScreenLoading () {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

// 调用加载停止
export function tryHideFullScreenLoading () {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

axios.defaults.timeout = 20000 // 发送请求后，20s还没有收到请求答复，就超时报错
axios.defaults.baseURL = ''

// http request 拦截器
axios.interceptors.request.use(config => {
  showFullScreenLoading() // 请求开始时加载
  // const token = getCookie('名称')注意使用的时候需要引入cookie方法，推荐js-cookie
  config.data = JSON.stringify(config.data)
  if (store.state.login) {
    config.headers = {
      'Content-Type': 'application/json'
    }
  } else if (store.state.downloads) {
    config.headers = {
      'Content-Type': 'application/json',
      Authorization: 'jwt ' + localStorage.getItem('token')
    }
    config.responseType = 'blob'
  } else {
    config.headers = {
      'Content-Type': 'application/json',
      Authorization: 'jwt ' + localStorage.getItem('token'),
      token: localStorage.getItem('token')
    }
  }
  return config
})

// http response 拦截器
axios.interceptors.response.use(
  response => {
    tryHideFullScreenLoading() // 响应结束关闭加载
    if (response.data.status !== undefined && response.data.status !== 0) {
      // token 失效
      if (response.data.status === 6) {
        vue.$router.push('/Login')
        vue.$message.error('账号过期，请重新登陆')
        return response
      }
      vue.$message.error(response.data.msg)
    }
    return response
  },
  err => {
    tryHideFullScreenLoading()
    if (err.response === undefined) {
      vue.$message.error('服务器响应异常')
      return
    }
    if (
      err.response.status === 504 ||
      err.response.status === 404 ||
      err.response.status === 500
    ) {
      vue.$message.error('server err')
    } else if (err.response.status === 403 || err.response.status === 401) {
      localStorage.clear()
      vue.$message.error('登录状态已结束,请重新登录')
      // vue.$router.replace({ path: '/Login' })
    } else if (err.response.status === 400) {
      vue.$message.error('参数格式错误')
    } else {
      vue.$message.error('未知错误')
    }
  }
)

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get (url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(response => {
        if (response) {
          resolve(response.data)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post (url, data = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, data)
      .then(
        response => {
          console.log(response)
          resolve(response.data)
        },
        err => {
          reject(err)
        }
      )
      .catch(e => {
        console.log(e)
      })
  })
}

/**
 * 封装del方法
 * @param url
 * @param del
 * @returns {Promise}
 */
export function del (url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, {
        params: params
      })
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function patch (url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      response => {
        resolve(response.data)
      },
      err => {
        reject(err)
      }
    )
  })
}

// 导入表格
export const uploadXlsx = axios.create({
  baseURL: '',
  timeout: 6000,
  headers: {
    'Content-Type': 'multipart/form-data',
    token: localStorage.getItem('token')
  }
})

/**
 * 导出文件方法
 * @param {String} method [请求方式]
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param {String} fileName [导出的文件名，例：test.xlsx]
 */
export function download (method = 'post', url, params, fileName) {
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: url,
      params: params,
      responseType: 'blob'
    }).then(res => {
      let reader = new FileReader()
      let data = res.data
      reader.onload = e => {
        if (
          e.target.result.indexOf('Result') !== -1 &&
          JSON.parse(e.target.result).Result === false
        ) {
          // 进行错误处理
        } else {
          if (!fileName) {
            let contentDisposition = res.headers['content-disposition']
            if (contentDisposition) {
              fileName = window.decodeURI(
                res.headers['content-disposition'].split('=')[2].split('""')[1],
                'UTF-8'
              )
            }
          }
          executeDownload(data, fileName)
        }
      }
      reader.readAsText(data)
      resolve(res.data)
    })
  })
}
//  模拟点击a 标签进行下载
function executeDownload (data, fileName) {
  if (!data) {
    return
  }
  let url = window.URL.createObjectURL(new Blob([data]))
  let link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}



// WEBPACK FOOTER //
// ./src/utils/http.js